import { PDFDocument, rgb } from 'pdf-lib'
import fontkit from '@pdf-lib/fontkit'
import { format } from 'date-fns'
import fontUrl from '~/assets/fonts/Montserrat-Medium.ttf'
import useAuthStore from '~/stores/auth'

export async function addWatermarkInPDF(blob: BlobPart) {
  const { authenticated, fullName, user } = useAuthStore()

  const fontBytes = await fetch(fontUrl).then((res) => res.arrayBuffer())
  const newBlob = new Blob([blob], { type: 'application/pdf' })
  const pdfBuffer = new Uint8Array(await newBlob.arrayBuffer())
  const pdfData = new Uint8Array(pdfBuffer)
  const pdfDoc = await PDFDocument.load(pdfData)
  pdfDoc.registerFontkit(fontkit)
  const font = await pdfDoc.embedFont(fontBytes)
  const pages = pdfDoc.getPages()
  const generateDate = format(new Date(), 'dd.MM.yyyy.')

  const watermarkPrefix = 'Generated by Benchmark Mineral Intelligence'
  const watermarkUserInfo = `${watermarkPrefix} for ${fullName}`
  const watermarkDistributionInfo = `${user?.email} on ${generateDate} Not for further distribution.`

  let completeWatermark = watermarkPrefix

  if (authenticated) {
    completeWatermark = `${watermarkUserInfo} - ${watermarkDistributionInfo}`
  }

  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  context.font = '10px Montserrat-Medium'

  const pixelText = context.measureText(completeWatermark).width + 27
  const { width: pageWidth, height } = pages[0].getSize()

  let watermarkLines = []
  if (pixelText > pageWidth) {
    watermarkLines = [watermarkUserInfo, watermarkDistributionInfo]
  } else {
    watermarkLines.push(completeWatermark)
  }

  pages.forEach((page) => {
    watermarkLines.forEach((line, index) => {
      page.drawText(line, {
        x: 27,
        y: height - 10 * (index + 1),
        size: 8,
        font,
        color: rgb(0, 0, 0),
        opacity: 0.25,
      })
    })
  })

  return pdfDoc.save()
}
